import React from 'react';
import '../styles/About.css'; // Arquivo de estilos

function About() {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="about-content">
          <div className="text-left">
            <h2>Excelência em <br />Desenvolvimento de Sistemas</h2>
            <p>Transformamos suas ideias em soluções inovadoras e eficientes para o seu negócio</p>
          </div>

          <div className="text-right">
            <p>
              Nossa missão é oferecer soluções tecnológicas que impulsionem o crescimento e a eficiência da sua empresa. 
              Com uma abordagem personalizada, desenvolvemos sistemas que atendem às suas necessidades específicas, proporcionando uma experiência única e otimizada.
            </p>
            <ul>
              <li>Desenvolvimento de software sob medida para atender suas demandas</li>
              <li>Integração de sistemas para maior eficiência e produtividade</li>
              <li>Soluções seguras e escaláveis para suportar o crescimento do seu negócio</li>
            </ul>
            <p className="italic">
              <em>Comprometidos com a excelência, utilizamos as melhores práticas e tecnologias de ponta para entregar resultados que superam as expectativas.</em>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
